<template>
  <div id="personal-information-row">
    <div class="title">
      {{ title }}
    </div>
    <div class="value">
      {{ value }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'PersonalInformationRow',
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
#personal-information-row {
  margin: .25rem 2rem;
  text-align: start;
}

.title {
  color: #989898;
  font-size: .75rem;
}

@media(max-width: 90rem) {
  #personal-information-row {
    margin: .25rem 1.25rem;
  }

  .title {
    font-size: .75rem;
  }

  .value {
    font-size: .75rem;
  }
}
</style>
